// extracted by mini-css-extract-plugin
module.exports = {"status":"RegistrationDetails_status__O1yUh","registrationDetailsPlaceholder":"RegistrationDetails_registrationDetailsPlaceholder__fHir8"};